import { lowerFirst, mapKeys, upperFirst } from 'lodash-es';
import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getChatApiUrl } from './chat.paths';
import { ChatUserNotificationPreferences } from './chat.types';

export type TokenResponse = {
  token: string;
  channelTypes: string[];
  channelGrants: string[];
};

const createGetStreamToken = async () => {
  const res = await http.post<ApiResponseBody<TokenResponse>>(getChatApiUrl.getStreamToken());

  return res.data.data;
};

// The backend's wire format keys its chat types in camelCase (e.g. "opoGeneral", "organManagement"),
// one character off from the PascalCase StreamChannelType enum values ("OpoGeneral", "OrganManagement")
// used everywhere else in the app. Translate at this one boundary so the rest of the codebase can keep
// using StreamChannelType-keyed objects without caring about the wire casing.
type WireChatUserNotificationPreferences = Record<string, boolean>;

const toWirePreferences = (data: ChatUserNotificationPreferences): WireChatUserNotificationPreferences =>
  mapKeys(data, (_, type) => lowerFirst(type));

const fromWirePreferences = (data: WireChatUserNotificationPreferences) =>
  mapKeys(data, (_, key) => upperFirst(key)) as ChatUserNotificationPreferences;

const getUserNotificationPreferences = async () => {
  const res = await http.get<ApiResponseBody<WireChatUserNotificationPreferences>>(
    getChatApiUrl.userNotificationPreferences(),
  );

  return fromWirePreferences(res.data.data);
};

const updateUserNotificationPreferences = async (data: ChatUserNotificationPreferences) => {
  const res = await http.put<ApiResponseBody<WireChatUserNotificationPreferences>>(
    getChatApiUrl.userNotificationPreferences(),
    toWirePreferences(data),
  );

  return fromWirePreferences(res.data.data);
};

export const chatApiFetcher = {
  createGetStreamToken,
  getUserNotificationPreferences,
  updateUserNotificationPreferences,
};
